const replaceInvertedQuotes = (query) => {
  if (query == null) return '';
  const value = String(query);
  return value.replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[`]/g, '"');
};

export default replaceInvertedQuotes;
